<script setup lang="ts">
import type { ListboxFilterProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { CommandInput } from '#ui-kit/ui/command'

defineOptions({
  inheritAttrs: false,
})

const props = defineProps<
  ListboxFilterProps & {
    class?: HTMLAttributes['class']
    loading?: boolean
  }
>()

const searchModel = defineModel<string>({ default: '' })
</script>

<template>
  <CommandInput v-bind="{ ...props, ...$attrs }" v-model="searchModel" />
</template>
